import { defineWebComponent } from "../webcomponents-utils";
import {WlMultipleComponents} from "./multipleComponents.component";

export * from './multipleComponents.component';
export default WlMultipleComponents;

defineWebComponent('wl-multiple-components', WlMultipleComponents);